import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../layout.css";
import maisLogo from "../assets/mais_logo.png";

const API = "https://prod1.maisirrig.com.sa";

export default function Login() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();

    try {
      setLoading(true);

      const res = await axios.post(`${API}/api/auth/login`, {
        username,
        password,
      });

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));

      navigate("/");
    } catch (err) {
      alert(err?.response?.data?.message || err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <header className="app-header">
        <div className="header-left">
          <img src={maisLogo} alt="Mais Logo" className="header-logo" />
        </div>

        <div className="header-center">
          <div className="company-title">
            Saudi Mais Co. For Irrigation Systems
          </div>
          <div className="company-subtitle">Production System</div>
        </div>

        <div className="header-right"></div>
      </header>

      <div className="container d-flex justify-content-center align-items-center login-body">
        <div className="card p-4 shadow-sm login-card">
          <h3 className="mb-3">Login</h3>

          <form onSubmit={handleLogin}>
            <div className="mb-3">
              <label className="form-label">Username</label>
              <input
                type="text"
                className="form-control"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter username"
                autoComplete="username"
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Password</label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                autoComplete="current-password"
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}